import TileIcon from '../svg/TileIcon'
import * as Config from '../../public/external-links'
interface Props {
  UserWorkplaceType: number
}

export default function FWOCustomerTailoredInformation(props: Props) {
  return (
    <>
      {(() => {
        switch (props.UserWorkplaceType) {
          case 1:
            return (
              <>
                <a href={`${Config.HOME_SMALL_BUSINESS_URL}`}>
                  <TileIcon name="smallbiz" />
                  <strong className="pl-2">Small business</strong>
                </a>
              </>
            )
          case 2:
            return (
              <>
                <a href={`${Config.HOME_INDEPENDANT_CONTRACTORS_URL}`}>
                  <TileIcon name="contractor" />
                  <strong className="pl-2">Independent contractors</strong>
                </a>
              </>
            )
          case 3:
            return (
              <>
                <a href={`${Config.HOME_HORTICULTURE_URL}`}>
                  <TileIcon name="horticulture" />
                  <strong className="pl-2">Horticulture</strong>
                </a>
              </>
            )
          case 4:
            return (
              <>
                <a href={`${Config.HOME_FAST_FOOD_RESTURANTS_CAFES_URL}`}>
                  <TileIcon name="knifefork" />
                  <strong className="pl-2">
                    Fast food, restaurants and cafes
                  </strong>
                </a>
              </>
            )
          default:
            return (
              <>
                <a href={`${Config.HOME_PAYCALC_URL}`}>
                  <TileIcon name="paycalc" />
                  <strong className="pl-2">Pay calculator</strong>
                </a>
              </>
            )
        }
      })()}
    </>
  )
}
